import React from "react";

const isDev = process.env.NODE_ENV === "development";

const targets = {
  tr: {
    // Türkçe sitedeyken İngilizce siteye git
    url: isDev ? "http://localhost:3001" : "https://www.villavillam.co.uk",
    flag: "/flags/gb.svg",
    title: "English",
    alt: "United Kingdom flag",
  },
  en: {
    // İngilizce sitedeyken Türkçe siteye git
    url: isDev ? "http://localhost:3000" : "https://www.villavillam.com.tr",
    flag: "/flags/tr.svg",
    title: "Türkçe",
    alt: "Flag of Türkiye",
  },
};

const SHOW_LANGUAGE_SWITCH = false; // true yapinca bayrak gorunur

const LanguageSwitch = () => {
  if (!SHOW_LANGUAGE_SWITCH) return <div className="ml-auto" />;
  // Sadece villavillam.com.tr (1) ve villavillam.co.uk (2) arasinda gecis var.
  // Diger siteler (ör. balayivillasikirala = 3) icin bayrak gosterilmez;
  // ancak basliktaki sag hizalama (ml-auto) korunsun diye bos bir bosluk doner.
  const site = process.env.NEXT_PUBLIC_SITE;
  if (site !== "1" && site !== "2") return <div className="ml-auto" />;
  const target = targets[process.env.NEXT_PUBLIC_LANGUAGE] || targets.tr;
  return (
    <a
      href={target.url}
      title={target.title}
      hrefLang={process.env.NEXT_PUBLIC_LANGUAGE === "en" ? "tr" : "en"}
      className="flex items-center justify-center shrink-0 ml-auto mr-4"
    >
      <img
        src={target.flag}
        alt={target.alt}
        width="32"
        height="24"
        className="block w-8 h-6 rounded-sm shadow-sm ring-1 ring-black/10"
      />
    </a>
  );
};

export default LanguageSwitch;
